export const logoMarquee = () => {
  let root = document.documentElement

  const marqueeTwo = document.querySelector('.logo-marquee__track--two')
  const marqueeThree = document.querySelector('.logo-marquee__track--three')

  const marqueeItems = document.querySelectorAll(
    '.logo-marquee__track--one .marquee-item',
  )

  if (marqueeItems.length > 0) {
    let currentTallest = 0
    let totalWidth = 0

    marqueeItems.forEach((logo) => {
      if (logo.offsetHeight > currentTallest) {
        currentTallest = logo.offsetHeight
      }
      totalWidth += logo.offsetWidth
    })

    const marqueeResize = () => {
      let intViewportWidth = window.innerWidth

      let trackSize = totalWidth + marqueeItems.length * 20

      if (trackSize < 1080) {
        trackSize = 1080
      } else if (trackSize < intViewportWidth) {
        trackSize = intViewportWidth
      }

      let marqueeTiming = trackSize / 4

      root.style.setProperty('--marqueeWidth', trackSize + 'px')
      root.style.setProperty('--antiMarqueeWidth', trackSize * -1 + 'px')
      root.style.setProperty('--marqueeItemHeight', currentTallest + 'px')
      root.style.setProperty(
        '--marqueetiming',
        marqueeTiming / marqueeItems.length + 's',
      )
    }

    window.addEventListener('load', () => {
      marqueeResize()
    })

    window.addEventListener('resize', () => {
      marqueeResize()
    })
  }
}
